export default __webpack_public_path__ + "static/media/maclogo.548c2a42.svg";